import React from 'react';

const LoadingSpinner2: React.FC = () => {
  return (
    <svg width="64" height="16" viewBox="0 0 64 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="8" fill="#FECE1F">
        <animate attributeName="opacity" calcMode="discrete" values="0;0.5;0.5;0.5" dur="0.8" repeatCount="indefinite" begin="0" />
      </circle>
      <circle cx="32" cy="8" r="8" fill="#FECE1F">
        <animate attributeName="opacity" calcMode="discrete" values="0;0;0.8;0.8" dur="0.8" repeatCount="indefinite" begin="0" />
      </circle>
      <circle cx="56" cy="8" r="8" fill="#FECE1F">
        <animate attributeName="opacity" calcMode="discrete" values="0;0;0;1" dur="0.8" repeatCount="indefinite" begin="0" />
      </circle>
    </svg>
  );
};

export { LoadingSpinner2 };
